export default __webpack_public_path__ + "static/media/task_06.c0986916.png";